/**
 * Provider names for app.module/app.server.module providers.
 * Use @Optional() when using these.
 */

import { InjectionToken } from '@angular/core';
import { IAuthenticationService } from '@core/authentication/authentication.models';

export const BUILD_NUMBER = new InjectionToken<boolean>('Build number from Azure DevOps. Not set locally.');
export const SENTRY = new InjectionToken<GenericObject>(
    'Sentry library. Either for node or browser, depending on context.'
);

export const AUTHENTICATION_SERVICE_TOKEN = new InjectionToken<IAuthenticationService>('AUTHENTICATION_SERVICE_TOKEN');
